export const consolidated = {
	excelButton: "Exportar a Excel",
	extract: "Extracto",
	filename: "extracto-zig",
	table: {
		section: "Sección",
		name: "Nombre",
		totalValue: "Valor Bruto",
		fee: "Tarifa",
		feeMin: "Tarifa Mínima",
		feeMax: "Tarifa Máxima",
		payValue: "A Recibir/A Pagar Zig",
	},
	formatFee: "De {{minFee}} a {{maxFee}}",
};
